// extracted by mini-css-extract-plugin
export default {"sectionContainer":"Skills_sectionContainer__JhInx","skillsContainer":"Skills_skillsContainer__z998J","skillSection":"Skills_skillSection__3Tnd+"};